import React, { memo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Globe from '@v4/components/common/FAIcons/Light/Globe'
import { useSettingsButton } from './SettingsButton.hooks'

const SettingsButton = props => {
	const [{ classes, className, label }, { handleClick }] = useSettingsButton(props)

	return (
		<button type="button" className={clsx(classes.root, className)} onClick={handleClick}>
			<span className={classes.content}>
				<Globe className={classes.icon} />
				{label}
			</span>
		</button>
	)
}

SettingsButton.propTypes = {
	className: PropTypes.string,
	label: PropTypes.string,
}

export default memo(SettingsButton)
